import { Box, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { AllPermissions } from "../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmDialog, { useConfirmDialog } from "../../Components/Confirmation/ConfirmDialog";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
import { useDispatch } from "react-redux";
import WSCommonDialog from "../../Components/Dialog/WSCommonDialog";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid2, { BulkAction, IColumns2 } from "../../Components/DataGrid/WSDataGrid2";
import http from "../../commonFunctions/httpClient";
import StatusUpdateModal from "./StatusUpdateModal"; 


export const EmployeeList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()

    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();

    const [selectedEmployees, setSelectedEmployees] = useState<any[]>([]);
    const [openMessageDialog, setOpenMessageDialog] = useState(false);
    const [messageText, setMessageText] = useState('');
    const [sending, setSending] = useState(false);

    const [openStatus, setOpenStatus] = useState(false);
const [statusDialogEmployee, setStatusDialogEmployee] = useState(null);
const [newStatus, setNewStatus] = useState("");
const [statusReason, setStatusReason] = useState("");



    AllPermissions.getInstance();
    const { add, edit } = AllPermissions.getUserPermission;
    useEffect(() => {
        updateMainHeader("Employee");
        breadCrumbsStore.updateBreadCrumbs([
            { "Employee": "" },
        ]);
    });
    const source = {
        url: "Employee/search",
        page: 1,
        pageSize: 10,
        filter: [

        ],
        sort: [{
            "field": "UpdatedAt",
            "direction": "desc"
        }],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
  if (action === "Edit") {
    navigate(`/employee/${row?.id}`)
  } else if (action === 'Delete') {
    openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
  } else if (action === 'View') {
    navigate(`/employee/detail/${row?.id}`)
  } else if (action === 'Status') {
    // Add this block
    setStatusDialogEmployee(row);
    setNewStatus(row.status || "Hold"); // Default status
    setStatusReason("");
    setOpenStatus(true);
  }
};


    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`Employee`, Method.DELETE, null, id);
        dispatch(resetDataComponent('employeeListGrid'));
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()
    };

    const handleSendMessage = async () => {
        console.log('message text is', messageText)
        if (!messageText.trim()) {
            showMessage("Message cannot be empty", "error");
            return;
        }

        console.log('selectedEmployees is', selectedEmployees)
        try {
            setSending(true);

            const response = await http.sendMessage("send-bulk-messages", {
                to: selectedEmployees.map(emp => emp.phoneNumber),
                type: "text",
                message: messageText
            });

            // Call your WhatsApp bulk API
            // let response = await callAPI(
            //     'Employee/send-whatsapp',
            //     Method.POST,
            //     { messages: payload }
            // );

            console.log('respnse is', response);
            dispatch(resetDataComponent('employeeListGrid'));
            showMessage("Messages sent successfully", "success");

            // cleanup
            setMessageText('');
            setOpenMessageDialog(false);
            setSelectedEmployees([]);

        } catch (error) {
            showMessage("Failed to send messages", "error");
        } finally {
            setSending(false);
        }
    };

    const columns: IColumns2[] = [
        {
            header: "Select All",
            fieldName: "checkbox",
            type: "checkbox"
        },
        {
            header: "Name",
            fieldName: "name",
            type: "default",
        },
        {
            header: "Phone",
            fieldName: "phoneNumber",
            tooltip: true,
            type: "default",
        },
        {
            header: "Expected Salary",
            fieldName: "expectedSalary",
            type: "default",
            isHide: isMobile,
        },
        {
            header: "Skill",
            fieldName: "skill",
            tooltip: true,
            type: "default",
        },
        {
            header: "Location",
            fieldName: "location",
            isHide: isMobile,
            type: "default",
        },
        {
            header: "Home Return Date",
            fieldName: "homeDate",
            isHide: isMobile,
            type: "date",
        },
        {
            header: "Previous Work",
            fieldName: "previousWorkPlace",
            tooltip: true,
            isHide: isMobile,
            type: "default",
        },
        {
            header: "Submitted On",
            fieldName: "createdAt",
            isHide: isMobile,
            type: "date",
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
actions: [edit ? "View" : undefined, edit ? "Edit" : undefined, "Status", "Delete"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
        },
    ];

    const handleClick = () => {
        navigate('/employee')
    }

    const transFormData = (data: any) => {
        if (data) {
            data.map((item: any) => {
                item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
            })
            return data
        }
    }

    const handleSelectedEmployees = (rows: any[]) => {
        setSelectedEmployees(rows);
    };

    const handleBulkAction = async (actionType: string) => {
        if (selectedEmployees.length === 0) {
            alert("No emoloyee selected!");
            return;
        }

        if (actionType === "SendMsg") {
            setOpenMessageDialog(true)
        }
    };

    const handleStatusModalClose = () => {
  setOpenStatus(false);
  setStatusDialogEmployee(null);
  setNewStatus("");
  setStatusReason("");
};

const handleStatusUpdate = async () => {
  if (statusDialogEmployee && newStatus) {
    // Call your API here
    // await dispatch(updateEmployeeStatus({ 
    //   id: statusDialogEmployee.id, 
    //   data: { status: newStatus, reason: statusReason || "" } 
    // })).unwrap();
    
    // Refresh grid after update
    dispatch(resetDataComponent('employeeListGrid'));
    handleStatusModalClose();
  }
};


    const bulkActions: BulkAction[] = [
        {
            label: "Send Message",
            icon: <WSIcons.Edit />,
            color: "#4CAF50",
            onClick: () => handleBulkAction("SendMsg")
        },
    ];

    const MessageForm = (
        <Box mt={5}>
            <TextField
                size="small"
                fullWidth
                multiline
                minRows={2}
                maxRows={4}
                placeholder="Type your message here..."
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
            />
        </Box>
    );

 const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  setNewStatus(e.target.value);
};

const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  setStatusReason(e.target.value);
};



    return (
        <>
            <Grid container spacing={2}>
                <WSDataGrid2
                    id="employeeListGrid"
                    title="Employee"
                    columns={columns}
                    source={source}
                    transFormData={transFormData}
                    addButton={add ? { label: "New", color: "secondary" } : undefined}
                    onAddButtonClick={handleClick}
                    searchBox={{ fieldName: 'phoneNumber' }}
                    columnAction
                    bulkActions={bulkActions}
                    handleCheckBoxChangedValues={handleSelectedEmployees} // Pass the handler to get selected order IDs
                    gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                />
            </Grid>

           <StatusUpdateModal
  open={openStatus}
  onClose={handleStatusModalClose}
  employee={statusDialogEmployee}
  statusValue={newStatus}
  reasonValue={statusReason}
  onStatusChange={handleStatusChange}
  onReasonChange={handleReasonChange}
  onUpdateStatus={handleStatusUpdate}
  loading={false}
/>


            <ConfirmDialog
                open={open}
                title={title}
                onConfirm={onConfirm}
                onClose={handleClose}
            />

            <WSCommonDialog
                open={openMessageDialog}
                title="Send WhatsApp Message"
                content={MessageForm}
                handleClose={() => setOpenMessageDialog(false)}
                actions={[
                    {
                        label: "Cancel",
                        onClick: () => setOpenMessageDialog(false)
                    },
                    {
                        label: sending ? "Sending..." : "Send",
                        onClick: handleSendMessage,
                        autoFocus: true
                    }
                ]}
            />
        </>
    )
})
